<template>
    <div class="expand-search">
        <span class="expand-search__label">{{ resultsOutsideSearchQuery }} <span v-html="$t('TotemFilterResult.expand_search')"></span></span>
        <TotemButton
            class="expand-search__button"
            color="primary"
            @click="goToAllItemsList"
            size="small"
            :label="$t('TotemFilterResult.expand_search_button')"
        />
   </div>
</template>

<script>
    export default {
        name: 'totem-expand-search',
        props: {
            filteredCount: Number,
            resultsOutsideSearchQuery: Number
        },
        methods: {
            goToAllItemsList () {
                this.$store.dispatch('Search/setViewType', null)
                this.$store.dispatch('Search/setMainPackage', null)
                this.$router.push({ 'name': 'all-packages-all-content' })
            }
        }
    }
</script>

<style lang="scss" scoped>
    .expand-search {
        display: flex;
        flex-direction: row;
        align-items: center;
        margin: 0 0 20px;

        [class*="desktop"] & {
            margin: 0;
            align-items: flex-start;
        }
        &__label {
            font-family: Nunito-Regular, sans-serif;
            font-size: 1.7rem;
        }
        &__button {
            font-family: Nunito-Regular, sans-serif;
            font-size: 1.7rem;
            margin: 0 0 0 15px;
        }
    }
</style>

